@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_125_437_172)
internal val Res.string.exp_content_nomi_aten: StringResource by lazy {
      StringResource("string:exp_content_nomi_aten", "exp_content_nomi_aten", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 85340, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 84520, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 86964, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 81444, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79116, 105),
      ))
    }

@delegate:ResourceContentHash(499_357_637)
internal val Res.string.exp_content_nomi_e_aggettivi_1_1: StringResource by lazy {
      StringResource("string:exp_content_nomi_e_aggettivi_1_1", "exp_content_nomi_e_aggettivi_1_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 85442, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 84614, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 87058, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 81538, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79222, 84),
      ))
    }

@delegate:ResourceContentHash(2_038_319_775)
internal val Res.string.exp_content_nomi_e_aggettivi_1_2: StringResource by lazy {
      StringResource("string:exp_content_nomi_e_aggettivi_1_2", "exp_content_nomi_e_aggettivi_1_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 85523, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 84703, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 87143, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 81623, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79307, 92),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_nomi_e_aggettivi_1_3: StringResource by lazy {
      StringResource("string:exp_content_nomi_e_aggettivi_1_3", "exp_content_nomi_e_aggettivi_1_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 85624, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 84808, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 87252, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 81716, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79400, 48),
      ))
    }

@delegate:ResourceContentHash(585_348_212)
internal val Res.string.exp_content_nomi_importanti_1: StringResource by lazy {
      StringResource("string:exp_content_nomi_importanti_1", "exp_content_nomi_importanti_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 85764, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 84944, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 87388, 141),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 81840, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79532, 117),
      ))
    }

@delegate:ResourceContentHash(-1_741_375_289)
internal val Res.string.exp_content_nomi_importanti_10: StringResource by lazy {
      StringResource("string:exp_content_nomi_importanti_10", "exp_content_nomi_importanti_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 85673, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 84861, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 87305, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 81765, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79449, 82),
      ))
    }

@delegate:ResourceContentHash(-1_101_766_907)
internal val Res.string.exp_content_nomi_importanti_2: StringResource by lazy {
      StringResource("string:exp_content_nomi_importanti_2", "exp_content_nomi_importanti_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 85890, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 85074, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 87530, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 81954, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79650, 53),
      ))
    }

@delegate:ResourceContentHash(-397_956_801)
internal val Res.string.exp_content_nomi_importanti_3: StringResource by lazy {
      StringResource("string:exp_content_nomi_importanti_3", "exp_content_nomi_importanti_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 85944, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 85140, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 87596, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 82016, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79704, 117),
      ))
    }

@delegate:ResourceContentHash(-407_920_722)
internal val Res.string.exp_content_nomi_importanti_4: StringResource by lazy {
      StringResource("string:exp_content_nomi_importanti_4", "exp_content_nomi_importanti_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 86094, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 85262, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 87730, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 82138, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79822, 101),
      ))
    }

@delegate:ResourceContentHash(-551_438_946)
internal val Res.string.exp_content_nomi_importanti_5: StringResource by lazy {
      StringResource("string:exp_content_nomi_importanti_5", "exp_content_nomi_importanti_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 86192, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 85372, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 87844, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 82236, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79924, 41),
      ))
    }

@delegate:ResourceContentHash(1_691_490_820)
internal val Res.string.exp_content_nomi_importanti_6: StringResource by lazy {
      StringResource("string:exp_content_nomi_importanti_6", "exp_content_nomi_importanti_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 86234, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 85414, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 87886, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 82278, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79966, 137),
      ))
    }

@delegate:ResourceContentHash(829_089_984)
internal val Res.string.exp_content_nomi_importanti_7: StringResource by lazy {
      StringResource("string:exp_content_nomi_importanti_7", "exp_content_nomi_importanti_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 86392, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 85576, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 88036, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 82416, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80104, 145),
      ))
    }

@delegate:ResourceContentHash(-128_462_859)
internal val Res.string.exp_content_nomi_importanti_8: StringResource by lazy {
      StringResource("string:exp_content_nomi_importanti_8", "exp_content_nomi_importanti_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 86542, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 85714, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 88182, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 82542, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80250, 109),
      ))
    }

@delegate:ResourceContentHash(-1_010_328_565)
internal val Res.string.exp_content_nomi_importanti_9: StringResource by lazy {
      StringResource("string:exp_content_nomi_importanti_9", "exp_content_nomi_importanti_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 86676, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 85848, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 88316, 173),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 82680, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80360, 149),
      ))
    }

@delegate:ResourceContentHash(-459_655_789)
internal val Res.string.exp_content_nomi_inpu: StringResource by lazy {
      StringResource("string:exp_content_nomi_inpu", "exp_content_nomi_inpu", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 86814, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 86018, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 88490, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 82822, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80510, 97),
      ))
    }

@delegate:ResourceContentHash(-516_729_018)
internal val Res.string.exp_content_nomi_nomi_nomi_1: StringResource by lazy {
      StringResource("string:exp_content_nomi_nomi_nomi_1", "exp_content_nomi_nomi_nomi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 86912, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 86128, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 88588, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 82928, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80608, 76),
      ))
    }

@delegate:ResourceContentHash(-68_766_586)
internal val Res.string.exp_content_nomi_nomi_nomi_2: StringResource by lazy {
      StringResource("string:exp_content_nomi_nomi_nomi_2", "exp_content_nomi_nomi_nomi_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 87017, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 86229, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 88677, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 83013, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80685, 84),
      ))
    }

@delegate:ResourceContentHash(1_501_961_676)
internal val Res.string.exp_content_nomi_nomi_nomi_3: StringResource by lazy {
      StringResource("string:exp_content_nomi_nomi_nomi_3", "exp_content_nomi_nomi_nomi_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 87110, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 86334, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 88774, 152),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 83110, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80770, 116),
      ))
    }

@delegate:ResourceContentHash(666_649_213)
internal val Res.string.exp_content_nomi_nomi_nomi_4: StringResource by lazy {
      StringResource("string:exp_content_nomi_nomi_nomi_4", "exp_content_nomi_nomi_nomi_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 87239, 168),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 86475, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 88927, 156),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 83235, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80887, 156),
      ))
    }

@delegate:ResourceContentHash(1_111_753_531)
internal val Res.string.exp_content_nomi_nomi_nomi_5: StringResource by lazy {
      StringResource("string:exp_content_nomi_nomi_nomi_5", "exp_content_nomi_nomi_nomi_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 87408, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 86628, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 89084, 152),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 83380, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81044, 124),
      ))
    }

@delegate:ResourceContentHash(1_756_459_152)
internal val Res.string.exp_content_nomi_nomi_nomi_6: StringResource by lazy {
      StringResource("string:exp_content_nomi_nomi_nomi_6", "exp_content_nomi_nomi_nomi_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 87529, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 86761, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 89237, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 83509, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81169, 56),
      ))
    }

@delegate:ResourceContentHash(-1_741_342_826)
internal val Res.string.exp_content_nomi_ptah: StringResource by lazy {
      StringResource("string:exp_content_nomi_ptah", "exp_content_nomi_ptah", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 87586, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 86822, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 89302, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 83566, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81226, 129),
      ))
    }

@delegate:ResourceContentHash(-281_618_992)
internal val Res.string.exp_content_nomi_veri: StringResource by lazy {
      StringResource("string:exp_content_nomi_veri", "exp_content_nomi_veri", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 87716, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 86952, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 89428, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 83684, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81356, 113),
      ))
    }

@delegate:ResourceContentHash(845_264_545)
internal val Res.string.exp_content_non_vanno_pronunciati_due_volte_servono_solo_: StringResource by
    lazy {
      StringResource("string:exp_content_non_vanno_pronunciati_due_volte_servono_solo_", "exp_content_non_vanno_pronunciati_due_volte_servono_solo_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 87858, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 87094, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 89554, 205),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 83806, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81470, 169),
      ))
    }

@delegate:ResourceContentHash(789_264_581)
internal val Res.string.exp_content_oggetti_sacri_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_oggetti_sacri_alyn_1", "exp_content_oggetti_sacri_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 88056, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 87272, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 89760, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 83980, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81640, 112),
      ))
    }

@delegate:ResourceContentHash(-1_267_017_896)
internal val Res.string.exp_content_oggetti_sacri_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_oggetti_sacri_nilo_1", "exp_content_oggetti_sacri_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 88185, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 87405, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 89885, 152),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 84093, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81753, 136),
      ))
    }

@delegate:ResourceContentHash(-501_387_119)
internal val Res.string.exp_content_oggetto_frase_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_oggetto_frase_alyn_1", "exp_content_oggetto_frase_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 88326, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 87554, 136),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 90038, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 84226, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81890, 132),
      ))
    }

@delegate:ResourceContentHash(-2_020_791_491)
internal val Res.string.exp_content_oggetto_frase_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_oggetto_frase_alyn_2", "exp_content_oggetto_frase_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 88467, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 87691, 136),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 90167, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 84363, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82023, 108),
      ))
    }

@delegate:ResourceContentHash(-317_720_696)
internal val Res.string.exp_content_oggetto_frase_alyn_3: StringResource by lazy {
      StringResource("string:exp_content_oggetto_frase_alyn_3", "exp_content_oggetto_frase_alyn_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 88580, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 87828, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 90284, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 84488, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82132, 124),
      ))
    }

@delegate:ResourceContentHash(-701_331_874)
internal val Res.string.exp_content_oggetto_frase_alyn_4: StringResource by lazy {
      StringResource("string:exp_content_oggetto_frase_alyn_4", "exp_content_oggetto_frase_alyn_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 88709, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 87953, 136),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 90409, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 84613, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82257, 108),
      ))
    }

@delegate:ResourceContentHash(-725_481_466)
internal val Res.string.exp_content_oggetto_frase_alyn_5: StringResource by lazy {
      StringResource("string:exp_content_oggetto_frase_alyn_5", "exp_content_oggetto_frase_alyn_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 88826, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 88090, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 90526, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 84722, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82366, 64),
      ))
    }

@delegate:ResourceContentHash(-152_616_428)
internal val Res.string.exp_content_oggetto_frase_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_oggetto_frase_nilo_1", "exp_content_oggetto_frase_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 88895, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 88155, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 90595, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 84783, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82431, 136),
      ))
    }

@delegate:ResourceContentHash(715_288_788)
internal val Res.string.exp_content_oggetto_frase_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_oggetto_frase_nilo_2", "exp_content_oggetto_frase_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 89028, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 88288, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 90728, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 84916, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82568, 100),
      ))
    }

@delegate:ResourceContentHash(-429_018_130)
internal val Res.string.exp_content_oggetto_frase_nilo_3: StringResource by lazy {
      StringResource("string:exp_content_oggetto_frase_nilo_3", "exp_content_oggetto_frase_nilo_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 89137, 136),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 88393, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 90837, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 85017, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82669, 124),
      ))
    }

@delegate:ResourceContentHash(1_593_664_600)
internal val Res.string.exp_content_oggetto_frase_nilo_4: StringResource by lazy {
      StringResource("string:exp_content_oggetto_frase_nilo_4", "exp_content_oggetto_frase_nilo_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 89274, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 88518, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 90962, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 85138, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82794, 56),
      ))
    }

@delegate:ResourceContentHash(1_695_793_283)
internal val Res.string.exp_content_oggi_impariamo_come_esprimere_il_possesso_in_: StringResource by
    lazy {
      StringResource("string:exp_content_oggi_impariamo_come_esprimere_il_possesso_in_", "exp_content_oggi_impariamo_come_esprimere_il_possesso_in_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 89335, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 88575, 197),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 91027, 225),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 85195, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82851, 193),
      ))
    }

@delegate:ResourceContentHash(-1_310_569_561)
internal val Res.string.exp_content_ogni_parola_si_pu_trovare_scritta_in_diverse_: StringResource by
    lazy {
      StringResource("string:exp_content_ogni_parola_si_pu_trovare_scritta_in_diverse_", "exp_content_ogni_parola_si_pu_trovare_scritta_in_diverse_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 89533, 277),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 88773, 265),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 91253, 277),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 85385, 249),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83045, 241),
      ))
    }

@delegate:ResourceContentHash(2_066_232_878)
internal val Res.string.exp_content_ora_che_abbiamo_studiato_i_segni_delle_person: StringResource by
    lazy {
      StringResource("string:exp_content_ora_che_abbiamo_studiato_i_segni_delle_person", "exp_content_ora_che_abbiamo_studiato_i_segni_delle_person", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 89811, 221),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 89039, 237),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 91531, 241),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 85635, 221),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83287, 205),
      ))
    }

@delegate:ResourceContentHash(-1_230_795_982)
internal val Res.string.exp_content_ora_conosciamo_anche_il_secondo_segno_della_p: StringResource by
    lazy {
      StringResource("string:exp_content_ora_conosciamo_anche_il_secondo_segno_della_p", "exp_content_ora_conosciamo_anche_il_secondo_segno_della_p", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 90033, 213),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 89277, 213),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 91773, 221),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 85857, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83493, 189),
      ))
    }

@delegate:ResourceContentHash(-149_248_777)
internal val Res.string.exp_content_ora_mettiamoci_alla_prova_con_i_quiz: StringResource by lazy {
      StringResource("string:exp_content_ora_mettiamoci_alla_prova_con_i_quiz", "exp_content_ora_mettiamoci_alla_prova_con_i_quiz", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 90247, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 89491, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 91995, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 86055, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83683, 112),
      ))
    }

@delegate:ResourceContentHash(-69_469_262)
internal val Res.string.exp_content_ora_passiamo_al_quiz_per_mettere_alla_prova_q: StringResource by
    lazy {
      StringResource("string:exp_content_ora_passiamo_al_quiz_per_mettere_alla_prova_q", "exp_content_ora_passiamo_al_quiz_per_mettere_alla_prova_q", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 90352, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 89608, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 92104, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 86164, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83796, 145),
      ))
    }

@delegate:ResourceContentHash(593_473_139)
internal val Res.string.exp_content_ora_proviamo_a_riconoscere_e_tradurre_l_apposizione:
    StringResource by lazy {
      StringResource("string:exp_content_ora_proviamo_a_riconoscere_e_tradurre_l_apposizione", "exp_content_ora_proviamo_a_riconoscere_e_tradurre_l_apposizione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 90506, 191),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 89762, 167),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 92250, 195),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 86322, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83942, 179),
      ))
    }

@delegate:ResourceContentHash(-252_674_180)
internal val Res.string.exp_content_ora_sappiamo_riconoscere_le_principali_varianti_del:
    StringResource by lazy {
      StringResource("string:exp_content_ora_sappiamo_riconoscere_le_principali_varianti_del", "exp_content_ora_sappiamo_riconoscere_le_principali_varianti_del", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 90698, 183),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 89930, 171),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 92446, 183),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 86486, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84122, 159),
      ))
    }

@delegate:ResourceContentHash(929_169_048)
internal val Res.string.exp_content_ora_siamo_pronti_per_fare_pratica_con_i_pross: StringResource by
    lazy {
      StringResource("string:exp_content_ora_siamo_pronti_per_fare_pratica_con_i_pross", "exp_content_ora_siamo_pronti_per_fare_pratica_con_i_pross", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 90882, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 90102, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 92630, 165),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 86654, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84282, 129),
      ))
    }

@delegate:ResourceContentHash(1_476_553_700)
internal val Res.string.exp_content_ovviamente_bisogna_ottimizzare_lo_spazio_quindi_il:
    StringResource by lazy {
      StringResource("string:exp_content_ovviamente_bisogna_ottimizzare_lo_spazio_quindi_il", "exp_content_ovviamente_bisogna_ottimizzare_lo_spazio_quindi_il", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 91016, 274),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 90256, 286),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 92796, 266),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 86792, 290),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84412, 250),
      ))
    }

@delegate:ResourceContentHash(1_936_381_476)
internal val Res.string.exp_content_ovviamente_le_vocali_esistevano_ma_non_veniva: StringResource by
    lazy {
      StringResource("string:exp_content_ovviamente_le_vocali_esistevano_ma_non_veniva", "exp_content_ovviamente_le_vocali_esistevano_ma_non_veniva", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 91291, 317),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 90543, 333),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 93063, 341),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 87083, 309),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84663, 305),
      ))
    }

@delegate:ResourceContentHash(1_204_560_420)
internal val Res.string.exp_content_parole_del_tempo_1: StringResource by lazy {
      StringResource("string:exp_content_parole_del_tempo_1", "exp_content_parole_del_tempo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 91609, 214),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 90877, 194),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 87393, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84969, 170),
      ))
    }

@delegate:ResourceContentHash(1_301_115_649)
internal val Res.string.exp_content_parole_di_luoghi_1: StringResource by lazy {
      StringResource("string:exp_content_parole_di_luoghi_1", "exp_content_parole_di_luoghi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 91824, 214),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 91072, 194),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 93405, 182),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 87576, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85140, 170),
      ))
    }

@delegate:ResourceContentHash(1_248_688_348)
internal val Res.string.exp_content_participi_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_1", "exp_content_participi_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 92911, 136),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 92031, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 94420, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 88515, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86095, 116),
      ))
    }

@delegate:ResourceContentHash(-1_414_514_365)
internal val Res.string.exp_content_participi_alyn_10: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_10", "exp_content_participi_alyn_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 92039, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 91267, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 93588, 193),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 87759, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85311, 185),
      ))
    }

@delegate:ResourceContentHash(1_733_514_124)
internal val Res.string.exp_content_participi_alyn_11: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_11", "exp_content_participi_alyn_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 92237, 317),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 91421, 285),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 93782, 305),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 87917, 281),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85497, 277),
      ))
    }

@delegate:ResourceContentHash(-2_071_042_789)
internal val Res.string.exp_content_participi_alyn_12: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_12", "exp_content_participi_alyn_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 92555, 225),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 91707, 197),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 94088, 197),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 88199, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85775, 201),
      ))
    }

@delegate:ResourceContentHash(-918_976_837)
internal val Res.string.exp_content_participi_alyn_13: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_13", "exp_content_participi_alyn_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 92781, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 91905, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 94286, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 88401, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85977, 117),
      ))
    }

@delegate:ResourceContentHash(762_591_575)
internal val Res.string.exp_content_participi_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_2", "exp_content_participi_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 93048, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 92180, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 94553, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 88652, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86212, 112),
      ))
    }

@delegate:ResourceContentHash(-168_279_394)
internal val Res.string.exp_content_participi_alyn_3: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_3", "exp_content_participi_alyn_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 93177, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 92277, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 94650, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 88745, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86325, 104),
      ))
    }

@delegate:ResourceContentHash(140_123_874)
internal val Res.string.exp_content_participi_alyn_4: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_4", "exp_content_participi_alyn_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 93302, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 92410, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 94787, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 88866, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86430, 108),
      ))
    }

@delegate:ResourceContentHash(1_167_111_450)
internal val Res.string.exp_content_participi_alyn_5: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_5", "exp_content_participi_alyn_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 93423, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 92527, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 94896, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 88987, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86539, 96),
      ))
    }

@delegate:ResourceContentHash(-1_261_283_089)
internal val Res.string.exp_content_participi_alyn_6: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_6", "exp_content_participi_alyn_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 93540, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 92636, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 95021, 140),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 89096, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86636, 136),
      ))
    }

@delegate:ResourceContentHash(1_521_072_821)
internal val Res.string.exp_content_participi_alyn_7: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_7", "exp_content_participi_alyn_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 93681, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 92789, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 95162, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 89237, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86773, 92),
      ))
    }

@delegate:ResourceContentHash(-974_661_372)
internal val Res.string.exp_content_participi_alyn_8: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_8", "exp_content_participi_alyn_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 93786, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 92886, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 95259, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 89330, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86866, 96),
      ))
    }

@delegate:ResourceContentHash(-6_327_975)
internal val Res.string.exp_content_participi_alyn_9: StringResource by lazy {
      StringResource("string:exp_content_participi_alyn_9", "exp_content_participi_alyn_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 93899, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 93003, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 95368, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 89439, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86963, 92),
      ))
    }

@delegate:ResourceContentHash(-1_901_781_100)
internal val Res.string.exp_content_participi_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_participi_nilo_1", "exp_content_participi_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 93992, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 93104, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 95457, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 89544, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87056, 44),
      ))
    }

@delegate:ResourceContentHash(1_191_255_672)
internal val Res.string.exp_content_particle_iw_1: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_1", "exp_content_particle_iw_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 95363, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 94411, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 96860, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 90863, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88319, 125),
      ))
    }

@delegate:ResourceContentHash(-1_778_113_633)
internal val Res.string.exp_content_particle_iw_10: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_10", "exp_content_particle_iw_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 94037, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 93149, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 95502, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 89589, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87101, 58),
      ))
    }

@delegate:ResourceContentHash(-576_269_309)
internal val Res.string.exp_content_particle_iw_11: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_11", "exp_content_particle_iw_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 94092, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 93208, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 95565, 150),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 89648, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87160, 138),
      ))
    }

@delegate:ResourceContentHash(-1_457_826_960)
internal val Res.string.exp_content_particle_iw_12: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_12", "exp_content_particle_iw_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 94219, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 93339, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 95716, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 89775, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87299, 66),
      ))
    }

@delegate:ResourceContentHash(-1_660_739_110)
internal val Res.string.exp_content_particle_iw_13: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_13", "exp_content_particle_iw_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 94298, 142),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 93410, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 95783, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 89842, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87366, 122),
      ))
    }

@delegate:ResourceContentHash(1_555_261_370)
internal val Res.string.exp_content_particle_iw_14: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_14", "exp_content_particle_iw_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 94441, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 93521, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 95906, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 89969, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87489, 110),
      ))
    }

@delegate:ResourceContentHash(-1_975_096_739)
internal val Res.string.exp_content_particle_iw_15: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_15", "exp_content_particle_iw_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 94564, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 93620, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 96041, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 90084, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87600, 118),
      ))
    }

@delegate:ResourceContentHash(1_155_189_971)
internal val Res.string.exp_content_particle_iw_16: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_16", "exp_content_particle_iw_16", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 94711, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 93755, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 96164, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 90223, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87719, 98),
      ))
    }

@delegate:ResourceContentHash(449_702_727)
internal val Res.string.exp_content_particle_iw_17: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_17", "exp_content_particle_iw_17", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 94826, 150),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 93866, 158),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 96283, 174),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 90334, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87818, 162),
      ))
    }

@delegate:ResourceContentHash(837_420_702)
internal val Res.string.exp_content_particle_iw_18: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_18", "exp_content_particle_iw_18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 94977, 202),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 94025, 198),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 96458, 222),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 90509, 202),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87981, 178),
      ))
    }

@delegate:ResourceContentHash(1_518_008_206)
internal val Res.string.exp_content_particle_iw_19: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_19", "exp_content_particle_iw_19", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 95180, 182),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 94224, 186),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 96681, 178),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 90712, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88160, 158),
      ))
    }

@delegate:ResourceContentHash(-1_862_332_645)
internal val Res.string.exp_content_particle_iw_2: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_2", "exp_content_particle_iw_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 96131, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 95127, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 97652, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 91579, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89047, 57),
      ))
    }

@delegate:ResourceContentHash(-1_436_298_103)
internal val Res.string.exp_content_particle_iw_20: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_20", "exp_content_particle_iw_20", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 95505, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 94525, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 96994, 126),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 90985, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88445, 102),
      ))
    }

@delegate:ResourceContentHash(1_459_795_161)
internal val Res.string.exp_content_particle_iw_21: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_21", "exp_content_particle_iw_21", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 95612, 150),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 94620, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 97121, 158),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 91100, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88548, 138),
      ))
    }

@delegate:ResourceContentHash(-606_524_361)
internal val Res.string.exp_content_particle_iw_22: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_22", "exp_content_particle_iw_22", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 95763, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 94759, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 97280, 42),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 91235, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88687, 38),
      ))
    }

@delegate:ResourceContentHash(2_013_257_826)
internal val Res.string.exp_content_particle_iw_23: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_23", "exp_content_particle_iw_23", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 95806, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 94802, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 97323, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 91274, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88726, 46),
      ))
    }

@delegate:ResourceContentHash(98_759_608)
internal val Res.string.exp_content_particle_iw_24: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_24", "exp_content_particle_iw_24", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 95857, 170),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 94853, 182),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 97374, 186),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 91321, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88773, 186),
      ))
    }

@delegate:ResourceContentHash(210_530_445)
internal val Res.string.exp_content_particle_iw_25: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_25", "exp_content_particle_iw_25", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 96028, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 95036, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 97561, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 91504, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88960, 86),
      ))
    }

@delegate:ResourceContentHash(-670_029_828)
internal val Res.string.exp_content_particle_iw_3: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_3", "exp_content_particle_iw_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 96353, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 95333, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 97866, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 91777, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89249, 81),
      ))
    }

@delegate:ResourceContentHash(-900_952_471)
internal val Res.string.exp_content_particle_iw_3_b: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_3_b", "exp_content_particle_iw_3_b", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 96197, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 95189, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 97714, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 91633, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89105, 143),
      ))
    }

@delegate:ResourceContentHash(401_620_799)
internal val Res.string.exp_content_particle_iw_4: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_4", "exp_content_particle_iw_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 96431, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 95411, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 97952, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 91851, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89331, 69),
      ))
    }

@delegate:ResourceContentHash(-1_591_497_716)
internal val Res.string.exp_content_particle_iw_5: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_5", "exp_content_particle_iw_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 96505, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 95493, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 98030, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 91921, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89401, 81),
      ))
    }

@delegate:ResourceContentHash(-1_242_820_016)
internal val Res.string.exp_content_particle_iw_6: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_6", "exp_content_particle_iw_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 96587, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 95579, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 98116, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 91999, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89483, 113),
      ))
    }

@delegate:ResourceContentHash(-1_982_714_702)
internal val Res.string.exp_content_particle_iw_7: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_7", "exp_content_particle_iw_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 96705, 161),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 95705, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 98242, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 92117, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89597, 145),
      ))
    }

@delegate:ResourceContentHash(381_251_957)
internal val Res.string.exp_content_particle_iw_8: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_8", "exp_content_particle_iw_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 96867, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 95859, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 98400, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 92271, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89743, 109),
      ))
    }

@delegate:ResourceContentHash(-1_657_498_368)
internal val Res.string.exp_content_particle_iw_9: StringResource by lazy {
      StringResource("string:exp_content_particle_iw_9", "exp_content_particle_iw_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 96989, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 95969, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 98526, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 92369, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89853, 77),
      ))
    }

@delegate:ResourceContentHash(-354_426_071)
internal val Res.string.exp_content_per_capire_il_senso_di_lettura_completa: StringResource by
    lazy {
      StringResource("string:exp_content_per_capire_il_senso_di_lettura_completa", "exp_content_per_capire_il_senso_di_lettura_completa", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 97059, 239),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 96047, 263),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 98620, 231),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 92439, 243),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89931, 227),
      ))
    }

@delegate:ResourceContentHash(614_692_584)
internal val Res.string.exp_content_per_capire_il_senso_di_lettura_quindi_bisogna: StringResource by
    lazy {
      StringResource("string:exp_content_per_capire_il_senso_di_lettura_quindi_bisogna", "exp_content_per_capire_il_senso_di_lettura_quindi_bisogna", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 97299, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 96311, 209),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 98852, 193),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 92683, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90159, 205),
      ))
    }

@delegate:ResourceContentHash(-394_880_462)
internal val Res.string.exp_content_per_convenzione_le_vocali_che_non_conosciamo_: StringResource by
    lazy {
      StringResource("string:exp_content_per_convenzione_le_vocali_che_non_conosciamo_", "exp_content_per_convenzione_le_vocali_che_non_conosciamo_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 97497, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 96521, 165),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 99046, 193),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 92873, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90365, 157),
      ))
    }

@delegate:ResourceContentHash(-464_940_304)
internal val Res.string.exp_content_per_decifrare_la_scritta_ci_serve_imparare_qu: StringResource by
    lazy {
      StringResource("string:exp_content_per_decifrare_la_scritta_ci_serve_imparare_qu", "exp_content_per_decifrare_la_scritta_ci_serve_imparare_qu", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 97663, 169),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 96687, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 99240, 177),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 93051, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90523, 157),
      ))
    }

@delegate:ResourceContentHash(-1_453_407_092)
internal val Res.string.exp_content_per_molti_nomi_per_sappiamo_la_pronuncia_orig: StringResource by
    lazy {
      StringResource("string:exp_content_per_molti_nomi_per_sappiamo_la_pronuncia_orig", "exp_content_per_molti_nomi_per_sappiamo_la_pronuncia_orig", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 97833, 241),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 96857, 245),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 99418, 261),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 93221, 217),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90681, 229),
      ))
    }

@delegate:ResourceContentHash(1_915_073_917)
internal val Res.string.exp_content_per_non_lasciare_mai_spazi_vuoti_gli_scribi_t: StringResource by
    lazy {
      StringResource("string:exp_content_per_non_lasciare_mai_spazi_vuoti_gli_scribi_t", "exp_content_per_non_lasciare_mai_spazi_vuoti_gli_scribi_t", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 98075, 345),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 97103, 333),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 99680, 345),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 93439, 325),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90911, 297),
      ))
    }

@delegate:ResourceContentHash(-540_227_048)
internal val Res.string.exp_content_per_ora_che_ci_penso_non_ti_ho_ancora_spiegat: StringResource by
    lazy {
      StringResource("string:exp_content_per_ora_che_ci_penso_non_ti_ho_ancora_spiegat", "exp_content_per_ora_che_ci_penso_non_ti_ho_ancora_spiegat", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 98421, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 97437, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 100026, 185),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 93765, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91209, 181),
      ))
    }

@delegate:ResourceContentHash(1_508_048_221)
internal val Res.string.exp_content_per_risolvere_l_ambiguit_possiamo_aggiungere_: StringResource by
    lazy {
      StringResource("string:exp_content_per_risolvere_l_ambiguit_possiamo_aggiungere_", "exp_content_per_risolvere_l_ambiguit_possiamo_aggiungere_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 98619, 305),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 97607, 261),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 100212, 269),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 93931, 269),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91391, 257),
      ))
    }

@delegate:ResourceContentHash(-656_262_171)
internal val Res.string.exp_content_per_risparmiare_spazio_o_motivi_artistici_gli: StringResource by
    lazy {
      StringResource("string:exp_content_per_risparmiare_spazio_o_motivi_artistici_gli", "exp_content_per_risparmiare_spazio_o_motivi_artistici_gli", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 98925, 293),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 97869, 285),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 100482, 313),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 94201, 273),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91649, 249),
      ))
    }

@delegate:ResourceContentHash(618_427_082)
internal val Res.string.exp_content_per_ultimo_un_epiteto_come_eletto_da_o_amato_da: StringResource
    by lazy {
      StringResource("string:exp_content_per_ultimo_un_epiteto_come_eletto_da_o_amato_da", "exp_content_per_ultimo_un_epiteto_come_eletto_da_o_amato_da", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 99219, 187),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 98155, 175),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 100796, 199),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 94475, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91899, 171),
      ))
    }

@delegate:ResourceContentHash(-1_815_194_787)
internal val Res.string.exp_content_possessivo_suffisso_1: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_1", "exp_content_possessivo_suffisso_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 100493, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 99433, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 102122, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 95705, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93109, 101),
      ))
    }

@delegate:ResourceContentHash(704_135_707)
internal val Res.string.exp_content_possessivo_suffisso_10: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_10", "exp_content_possessivo_suffisso_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 99407, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 98331, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 100996, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 94651, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92071, 66),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString8Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_content_nomi_aten", Res.string.exp_content_nomi_aten)
  map.put("exp_content_nomi_e_aggettivi_1_1", Res.string.exp_content_nomi_e_aggettivi_1_1)
  map.put("exp_content_nomi_e_aggettivi_1_2", Res.string.exp_content_nomi_e_aggettivi_1_2)
  map.put("exp_content_nomi_e_aggettivi_1_3", Res.string.exp_content_nomi_e_aggettivi_1_3)
  map.put("exp_content_nomi_importanti_1", Res.string.exp_content_nomi_importanti_1)
  map.put("exp_content_nomi_importanti_10", Res.string.exp_content_nomi_importanti_10)
  map.put("exp_content_nomi_importanti_2", Res.string.exp_content_nomi_importanti_2)
  map.put("exp_content_nomi_importanti_3", Res.string.exp_content_nomi_importanti_3)
  map.put("exp_content_nomi_importanti_4", Res.string.exp_content_nomi_importanti_4)
  map.put("exp_content_nomi_importanti_5", Res.string.exp_content_nomi_importanti_5)
  map.put("exp_content_nomi_importanti_6", Res.string.exp_content_nomi_importanti_6)
  map.put("exp_content_nomi_importanti_7", Res.string.exp_content_nomi_importanti_7)
  map.put("exp_content_nomi_importanti_8", Res.string.exp_content_nomi_importanti_8)
  map.put("exp_content_nomi_importanti_9", Res.string.exp_content_nomi_importanti_9)
  map.put("exp_content_nomi_inpu", Res.string.exp_content_nomi_inpu)
  map.put("exp_content_nomi_nomi_nomi_1", Res.string.exp_content_nomi_nomi_nomi_1)
  map.put("exp_content_nomi_nomi_nomi_2", Res.string.exp_content_nomi_nomi_nomi_2)
  map.put("exp_content_nomi_nomi_nomi_3", Res.string.exp_content_nomi_nomi_nomi_3)
  map.put("exp_content_nomi_nomi_nomi_4", Res.string.exp_content_nomi_nomi_nomi_4)
  map.put("exp_content_nomi_nomi_nomi_5", Res.string.exp_content_nomi_nomi_nomi_5)
  map.put("exp_content_nomi_nomi_nomi_6", Res.string.exp_content_nomi_nomi_nomi_6)
  map.put("exp_content_nomi_ptah", Res.string.exp_content_nomi_ptah)
  map.put("exp_content_nomi_veri", Res.string.exp_content_nomi_veri)
  map.put("exp_content_non_vanno_pronunciati_due_volte_servono_solo_", Res.string.exp_content_non_vanno_pronunciati_due_volte_servono_solo_)
  map.put("exp_content_oggetti_sacri_alyn_1", Res.string.exp_content_oggetti_sacri_alyn_1)
  map.put("exp_content_oggetti_sacri_nilo_1", Res.string.exp_content_oggetti_sacri_nilo_1)
  map.put("exp_content_oggetto_frase_alyn_1", Res.string.exp_content_oggetto_frase_alyn_1)
  map.put("exp_content_oggetto_frase_alyn_2", Res.string.exp_content_oggetto_frase_alyn_2)
  map.put("exp_content_oggetto_frase_alyn_3", Res.string.exp_content_oggetto_frase_alyn_3)
  map.put("exp_content_oggetto_frase_alyn_4", Res.string.exp_content_oggetto_frase_alyn_4)
  map.put("exp_content_oggetto_frase_alyn_5", Res.string.exp_content_oggetto_frase_alyn_5)
  map.put("exp_content_oggetto_frase_nilo_1", Res.string.exp_content_oggetto_frase_nilo_1)
  map.put("exp_content_oggetto_frase_nilo_2", Res.string.exp_content_oggetto_frase_nilo_2)
  map.put("exp_content_oggetto_frase_nilo_3", Res.string.exp_content_oggetto_frase_nilo_3)
  map.put("exp_content_oggetto_frase_nilo_4", Res.string.exp_content_oggetto_frase_nilo_4)
  map.put("exp_content_oggi_impariamo_come_esprimere_il_possesso_in_", Res.string.exp_content_oggi_impariamo_come_esprimere_il_possesso_in_)
  map.put("exp_content_ogni_parola_si_pu_trovare_scritta_in_diverse_", Res.string.exp_content_ogni_parola_si_pu_trovare_scritta_in_diverse_)
  map.put("exp_content_ora_che_abbiamo_studiato_i_segni_delle_person", Res.string.exp_content_ora_che_abbiamo_studiato_i_segni_delle_person)
  map.put("exp_content_ora_conosciamo_anche_il_secondo_segno_della_p", Res.string.exp_content_ora_conosciamo_anche_il_secondo_segno_della_p)
  map.put("exp_content_ora_mettiamoci_alla_prova_con_i_quiz", Res.string.exp_content_ora_mettiamoci_alla_prova_con_i_quiz)
  map.put("exp_content_ora_passiamo_al_quiz_per_mettere_alla_prova_q", Res.string.exp_content_ora_passiamo_al_quiz_per_mettere_alla_prova_q)
  map.put("exp_content_ora_proviamo_a_riconoscere_e_tradurre_l_apposizione", Res.string.exp_content_ora_proviamo_a_riconoscere_e_tradurre_l_apposizione)
  map.put("exp_content_ora_sappiamo_riconoscere_le_principali_varianti_del", Res.string.exp_content_ora_sappiamo_riconoscere_le_principali_varianti_del)
  map.put("exp_content_ora_siamo_pronti_per_fare_pratica_con_i_pross", Res.string.exp_content_ora_siamo_pronti_per_fare_pratica_con_i_pross)
  map.put("exp_content_ovviamente_bisogna_ottimizzare_lo_spazio_quindi_il", Res.string.exp_content_ovviamente_bisogna_ottimizzare_lo_spazio_quindi_il)
  map.put("exp_content_ovviamente_le_vocali_esistevano_ma_non_veniva", Res.string.exp_content_ovviamente_le_vocali_esistevano_ma_non_veniva)
  map.put("exp_content_parole_del_tempo_1", Res.string.exp_content_parole_del_tempo_1)
  map.put("exp_content_parole_di_luoghi_1", Res.string.exp_content_parole_di_luoghi_1)
  map.put("exp_content_participi_alyn_1", Res.string.exp_content_participi_alyn_1)
  map.put("exp_content_participi_alyn_10", Res.string.exp_content_participi_alyn_10)
  map.put("exp_content_participi_alyn_11", Res.string.exp_content_participi_alyn_11)
  map.put("exp_content_participi_alyn_12", Res.string.exp_content_participi_alyn_12)
  map.put("exp_content_participi_alyn_13", Res.string.exp_content_participi_alyn_13)
  map.put("exp_content_participi_alyn_2", Res.string.exp_content_participi_alyn_2)
  map.put("exp_content_participi_alyn_3", Res.string.exp_content_participi_alyn_3)
  map.put("exp_content_participi_alyn_4", Res.string.exp_content_participi_alyn_4)
  map.put("exp_content_participi_alyn_5", Res.string.exp_content_participi_alyn_5)
  map.put("exp_content_participi_alyn_6", Res.string.exp_content_participi_alyn_6)
  map.put("exp_content_participi_alyn_7", Res.string.exp_content_participi_alyn_7)
  map.put("exp_content_participi_alyn_8", Res.string.exp_content_participi_alyn_8)
  map.put("exp_content_participi_alyn_9", Res.string.exp_content_participi_alyn_9)
  map.put("exp_content_participi_nilo_1", Res.string.exp_content_participi_nilo_1)
  map.put("exp_content_particle_iw_1", Res.string.exp_content_particle_iw_1)
  map.put("exp_content_particle_iw_10", Res.string.exp_content_particle_iw_10)
  map.put("exp_content_particle_iw_11", Res.string.exp_content_particle_iw_11)
  map.put("exp_content_particle_iw_12", Res.string.exp_content_particle_iw_12)
  map.put("exp_content_particle_iw_13", Res.string.exp_content_particle_iw_13)
  map.put("exp_content_particle_iw_14", Res.string.exp_content_particle_iw_14)
  map.put("exp_content_particle_iw_15", Res.string.exp_content_particle_iw_15)
  map.put("exp_content_particle_iw_16", Res.string.exp_content_particle_iw_16)
  map.put("exp_content_particle_iw_17", Res.string.exp_content_particle_iw_17)
  map.put("exp_content_particle_iw_18", Res.string.exp_content_particle_iw_18)
  map.put("exp_content_particle_iw_19", Res.string.exp_content_particle_iw_19)
  map.put("exp_content_particle_iw_2", Res.string.exp_content_particle_iw_2)
  map.put("exp_content_particle_iw_20", Res.string.exp_content_particle_iw_20)
  map.put("exp_content_particle_iw_21", Res.string.exp_content_particle_iw_21)
  map.put("exp_content_particle_iw_22", Res.string.exp_content_particle_iw_22)
  map.put("exp_content_particle_iw_23", Res.string.exp_content_particle_iw_23)
  map.put("exp_content_particle_iw_24", Res.string.exp_content_particle_iw_24)
  map.put("exp_content_particle_iw_25", Res.string.exp_content_particle_iw_25)
  map.put("exp_content_particle_iw_3", Res.string.exp_content_particle_iw_3)
  map.put("exp_content_particle_iw_3_b", Res.string.exp_content_particle_iw_3_b)
  map.put("exp_content_particle_iw_4", Res.string.exp_content_particle_iw_4)
  map.put("exp_content_particle_iw_5", Res.string.exp_content_particle_iw_5)
  map.put("exp_content_particle_iw_6", Res.string.exp_content_particle_iw_6)
  map.put("exp_content_particle_iw_7", Res.string.exp_content_particle_iw_7)
  map.put("exp_content_particle_iw_8", Res.string.exp_content_particle_iw_8)
  map.put("exp_content_particle_iw_9", Res.string.exp_content_particle_iw_9)
  map.put("exp_content_per_capire_il_senso_di_lettura_completa", Res.string.exp_content_per_capire_il_senso_di_lettura_completa)
  map.put("exp_content_per_capire_il_senso_di_lettura_quindi_bisogna", Res.string.exp_content_per_capire_il_senso_di_lettura_quindi_bisogna)
  map.put("exp_content_per_convenzione_le_vocali_che_non_conosciamo_", Res.string.exp_content_per_convenzione_le_vocali_che_non_conosciamo_)
  map.put("exp_content_per_decifrare_la_scritta_ci_serve_imparare_qu", Res.string.exp_content_per_decifrare_la_scritta_ci_serve_imparare_qu)
  map.put("exp_content_per_molti_nomi_per_sappiamo_la_pronuncia_orig", Res.string.exp_content_per_molti_nomi_per_sappiamo_la_pronuncia_orig)
  map.put("exp_content_per_non_lasciare_mai_spazi_vuoti_gli_scribi_t", Res.string.exp_content_per_non_lasciare_mai_spazi_vuoti_gli_scribi_t)
  map.put("exp_content_per_ora_che_ci_penso_non_ti_ho_ancora_spiegat", Res.string.exp_content_per_ora_che_ci_penso_non_ti_ho_ancora_spiegat)
  map.put("exp_content_per_risolvere_l_ambiguit_possiamo_aggiungere_", Res.string.exp_content_per_risolvere_l_ambiguit_possiamo_aggiungere_)
  map.put("exp_content_per_risparmiare_spazio_o_motivi_artistici_gli", Res.string.exp_content_per_risparmiare_spazio_o_motivi_artistici_gli)
  map.put("exp_content_per_ultimo_un_epiteto_come_eletto_da_o_amato_da", Res.string.exp_content_per_ultimo_un_epiteto_come_eletto_da_o_amato_da)
  map.put("exp_content_possessivo_suffisso_1", Res.string.exp_content_possessivo_suffisso_1)
  map.put("exp_content_possessivo_suffisso_10", Res.string.exp_content_possessivo_suffisso_10)
}
